/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { createContext, useCallback, useContext, useMemo, useRef } from 'react';
import { MOBILE_MORE_TAB_ROUTE } from './navigationManifest';

type LastMainTabContextValue = {
  lastTabRoute: string;
  lastTabLabel: string;
  rememberTab: (route: string, label: string) => void;
};

const LastMainTabContext = createContext<LastMainTabContextValue | null>(null);

export const DEFAULT_MAIN_TAB_ROUTE = 'Home';
export const DEFAULT_MAIN_TAB_LABEL = 'Inicio';

export function LastMainTabProvider({ children }: { children: React.ReactNode }) {
  const lastTabRouteRef = useRef(DEFAULT_MAIN_TAB_ROUTE);
  const lastTabLabelRef = useRef(DEFAULT_MAIN_TAB_LABEL);

  const rememberTab = useCallback((route: string, label: string) => {
    if (route === MOBILE_MORE_TAB_ROUTE || route === 'Reports') return;
    lastTabRouteRef.current = route;
    lastTabLabelRef.current = label;
  }, []);

  const value = useMemo(
    () => ({
      get lastTabRoute() {
        return lastTabRouteRef.current;
      },
      get lastTabLabel() {
        return lastTabLabelRef.current;
      },
      rememberTab,
    }),
    [rememberTab]
  );

  return <LastMainTabContext.Provider value={value}>{children}</LastMainTabContext.Provider>;
}

export function useLastMainTabOptional() {
  return useContext(LastMainTabContext);
}
